module.exports = __webpack_public_path__ + "img/icon-save.25685f16.svg";